/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { catalogEntriesComponentGroupsCatalogEntryIdPut } from '../fn/component-groups/catalog-entries-component-groups-catalog-entry-id-put';
import { CatalogEntriesComponentGroupsCatalogEntryIdPut$Params } from '../fn/component-groups/catalog-entries-component-groups-catalog-entry-id-put';
import { catalogEntriesPizzaComponentsCatalogEntryIdRelationshipsGet } from '../fn/component-groups/catalog-entries-pizza-components-catalog-entry-id-relationships-get';
import { CatalogEntriesPizzaComponentsCatalogEntryIdRelationshipsGet$Params } from '../fn/component-groups/catalog-entries-pizza-components-catalog-entry-id-relationships-get';
import { ComponentGroup } from '../models/component-group';
import { ComponentGroups } from '../models/component-groups';
import { tenantsTenantIdCatalogEntriesComponentGroupsGet } from '../fn/component-groups/tenants-tenant-id-catalog-entries-component-groups-get';
import { TenantsTenantIdCatalogEntriesComponentGroupsGet$Params } from '../fn/component-groups/tenants-tenant-id-catalog-entries-component-groups-get';
import { tenantsTenantIdCatalogEntriesComponentGroupsPost } from '../fn/component-groups/tenants-tenant-id-catalog-entries-component-groups-post';
import { TenantsTenantIdCatalogEntriesComponentGroupsPost$Params } from '../fn/component-groups/tenants-tenant-id-catalog-entries-component-groups-post';

@Injectable({ providedIn: 'root' })
export class ComponentGroupsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `catalogEntriesPizzaComponentsCatalogEntryIdRelationshipsGet()` */
  static readonly CatalogEntriesPizzaComponentsCatalogEntryIdRelationshipsGetPath = '/catalog-entries/pizza_components/{catalogEntryId}/relationships';

  /**
   * Gets all component groups that contain a given catalogEntryId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `catalogEntriesPizzaComponentsCatalogEntryIdRelationshipsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  catalogEntriesPizzaComponentsCatalogEntryIdRelationshipsGet$Response(params: CatalogEntriesPizzaComponentsCatalogEntryIdRelationshipsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ComponentGroups>> {
    return catalogEntriesPizzaComponentsCatalogEntryIdRelationshipsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all component groups that contain a given catalogEntryId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `catalogEntriesPizzaComponentsCatalogEntryIdRelationshipsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  catalogEntriesPizzaComponentsCatalogEntryIdRelationshipsGet(params: CatalogEntriesPizzaComponentsCatalogEntryIdRelationshipsGet$Params, context?: HttpContext): Observable<ComponentGroups> {
    return this.catalogEntriesPizzaComponentsCatalogEntryIdRelationshipsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ComponentGroups>): ComponentGroups => r.body)
    );
  }

  /** Path part for operation `tenantsTenantIdCatalogEntriesComponentGroupsGet()` */
  static readonly TenantsTenantIdCatalogEntriesComponentGroupsGetPath = '/tenants/{tenantId}/catalog-entries/component-groups';

  /**
   * Gets a list of Catalog entries of type Component Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsTenantIdCatalogEntriesComponentGroupsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsTenantIdCatalogEntriesComponentGroupsGet$Response(params: TenantsTenantIdCatalogEntriesComponentGroupsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ComponentGroups>> {
    return tenantsTenantIdCatalogEntriesComponentGroupsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of Catalog entries of type Component Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsTenantIdCatalogEntriesComponentGroupsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsTenantIdCatalogEntriesComponentGroupsGet(params: TenantsTenantIdCatalogEntriesComponentGroupsGet$Params, context?: HttpContext): Observable<ComponentGroups> {
    return this.tenantsTenantIdCatalogEntriesComponentGroupsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ComponentGroups>): ComponentGroups => r.body)
    );
  }

  /** Path part for operation `tenantsTenantIdCatalogEntriesComponentGroupsPost()` */
  static readonly TenantsTenantIdCatalogEntriesComponentGroupsPostPath = '/tenants/{tenantId}/catalog-entries/component-groups';

  /**
   * Creates a component groups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsTenantIdCatalogEntriesComponentGroupsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsTenantIdCatalogEntriesComponentGroupsPost$Response(params: TenantsTenantIdCatalogEntriesComponentGroupsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ComponentGroup>> {
    return tenantsTenantIdCatalogEntriesComponentGroupsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a component groups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsTenantIdCatalogEntriesComponentGroupsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsTenantIdCatalogEntriesComponentGroupsPost(params: TenantsTenantIdCatalogEntriesComponentGroupsPost$Params, context?: HttpContext): Observable<ComponentGroup> {
    return this.tenantsTenantIdCatalogEntriesComponentGroupsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ComponentGroup>): ComponentGroup => r.body)
    );
  }

  /** Path part for operation `catalogEntriesComponentGroupsCatalogEntryIdPut()` */
  static readonly CatalogEntriesComponentGroupsCatalogEntryIdPutPath = '/catalog-entries/component-groups/{catalogEntryId}';

  /**
   * Updates a component group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `catalogEntriesComponentGroupsCatalogEntryIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  catalogEntriesComponentGroupsCatalogEntryIdPut$Response(params: CatalogEntriesComponentGroupsCatalogEntryIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ComponentGroup>> {
    return catalogEntriesComponentGroupsCatalogEntryIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a component group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `catalogEntriesComponentGroupsCatalogEntryIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  catalogEntriesComponentGroupsCatalogEntryIdPut(params: CatalogEntriesComponentGroupsCatalogEntryIdPut$Params, context?: HttpContext): Observable<ComponentGroup> {
    return this.catalogEntriesComponentGroupsCatalogEntryIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<ComponentGroup>): ComponentGroup => r.body)
    );
  }

}
